import { createFileRoute } from '@tanstack/react-router'
import { listSearchSchema } from '@/lib/list-search-schema'
import ReleaseManagement from '@/pages/ReleaseManagement'

export const Route = createFileRoute('/_authenticated/releases')({
  validateSearch: listSearchSchema,
  component: ReleaseManagement,
})
